import './PageTitle.scss';

import { Title } from '@travelwin/core';
import { ReactElement } from 'react';

import BackButton from '../BackButton';

interface Props {
  title: string | ReactElement<typeof Title>;
  hasBackButton?: boolean;
  backButtonLabel?: string;
  'data-testid'?: string;
  onBackButtonClick?: () => void;
}

const className = 'c-PageTitle';

const PageTitle = ({
  title,
  hasBackButton = false,
  backButtonLabel,
  'data-testid': dataTestId,
  onBackButtonClick,
}: Props) => (
  <div className={className}>
    <div className={`${className}__container`}>
      {hasBackButton && (
        <BackButton
          backButtonLabel={backButtonLabel}
          onBackButtonClick={onBackButtonClick}
        />
      )}
      {typeof title === 'string' ? (
        <h1 className={`${className}__page-title`} data-testid={dataTestId}>
          {title}
        </h1>
      ) : (
        title
      )}
      {hasBackButton && <div className={`${className}__padding`}></div>}
    </div>
  </div>
);

export default PageTitle;
